import i18n from 'i18n';

export function getObjectById(collection, id) {
    const result = collection.filter(item => item.id === id);
    if (result.length) {
        return result[0]
    }
    return null
}

export function sortAlphabetically(collection, keyName, options) {
    let type = 'asc';
    let localeCompare = false;
    if (options && options.type) {
        type = options.type;
    }
    if (options && options.localeCompare) {
        localeCompare = options.localeCompare;
    }
    return collection.slice().sort((a, b) => {
        let aCompare = a[keyName];
        let bCompare = b[keyName];
        if (typeof aCompare === 'string') {
            if (localeCompare) {
                let result = aCompare.localeCompare(bCompare);
                if (type === 'desc') {
                    return -result;
                }
                return result;

            }
            aCompare = aCompare.toLowerCase();
            bCompare = bCompare.toLowerCase();
        }
        if (aCompare < bCompare) return (type === 'asc' ? -1 : 1);
        else if (aCompare > bCompare) return (type === 'asc' ? 1 : -1);
        return 0;

    })
}


export function nativeWordDuplicity(nWord, cardList) {
    const result = cardList.filter((c) => {
        return c.n_word.toLowerCase().trim() === nWord.toLowerCase()
    });
    if (result.length) {
        return result[0];
    }
    return null;
}

export function foreignWordDuplicity(fWord, cardList) {
    const result = cardList.filter((c) => {
        return c.f_word.toLowerCase().trim() === fWord.toLowerCase()
    });
    if (result.length) {
        return result[0]
    }
    return null;
}

export function trimValues(dict) {
    for (const key in dict) {
        if (dict.hasOwnProperty(key)) {
            if (typeof dict[key] === "string") {
                dict[key] = dict[key].trim();
            }
        }
    }
    return dict
}


export function translateDifficulty(difficulty) {
    if (difficulty.code === 'A1') return i18n.t('elementary');
    if (difficulty.code === 'A2') return i18n.t('pre_intermediate');
    if (difficulty.code === 'B1') return i18n.t('intermediate');
    if (difficulty.code === 'B2') return i18n.t('upper_intermediate');
    if (difficulty.code === 'C1') return i18n.t('advanced');
    if (difficulty.code === 'C2') return i18n.t('proficient');
    return difficulty.name;
}

export function capitalizeFirstLetter(input) {
    if (typeof input === "string") {
        return input.charAt(0).toUpperCase() + input.slice(1);
    }
    return input
}


export function getBrowserInfo(){
    var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
        tem=/\brv[ :]+(\d+)/g.exec(ua) || [];
        return {name:'IE',version:(tem[1]||'')};
        }
    if(M[1]==='Chrome'){
        tem=ua.match(/\bOPR\/(\d+)/)
        if(tem!=null)   {return {name:'Opera', version:tem[1]};}
        }
    M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
    return {
      name: M[0],
      version: M[1]
    };
 }





// WEBPACK FOOTER //
// ./src/utils.js